export default __webpack_public_path__ + "static/media/AppraiserPersona.505c89e9.png";